import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import type { AppDispatch } from '../index';

interface DialogState {
  isOpen: boolean;
  type: 'success' | 'error' | 'confirm' | 'warning';
  message: string;
  onConfirm?: () => void;
  onClose?: () => void;
}

const initialState: DialogState = {
  isOpen: false,
  type: 'success',
  message: '',
  onConfirm: undefined,
  onClose: undefined,
};

export const setDialog = createAsyncThunk(
  'dialog/setDialog',
  async (
    {
      isOpen,
      type,
      message,
      onConfirm,
      onClose,
    }: {
      isOpen: boolean;
      type: 'success' | 'error' | 'confirm' | 'warning';
      message: string;
      onConfirm?: () => void;
      onClose?: () => void;
    },
    { rejectWithValue }
  ) => {
    try {
      return {
        isOpen,
        type,
        message,
        onConfirm,
        onClose,
      };
    } catch (error: any) {
      return rejectWithValue(error.message || 'Erro ao exibir diálogo');
    }
  }
);

const dialogSlice = createSlice({
  name: 'dialog',
  initialState,
  reducers: {
    closeDialog: (state) => {
      state.isOpen = false;
      state.onConfirm = undefined;
      state.onClose = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(setDialog.pending, (state) => {
        state.isOpen = false;
      })
      .addCase(setDialog.fulfilled, (state, action) => {
        state.isOpen = action.payload.isOpen;
        state.type = action.payload.type;
        state.message = action.payload.message;
        state.onConfirm = action.payload.onConfirm;
        state.onClose = action.payload.onClose;
      })
      .addCase(setDialog.rejected, (state) => {
        state.isOpen = false;
      });
  },
});

export const dialog = {
  alert: (
    dispatch: AppDispatch,
    message: string,
    type: 'success' | 'error' | 'warning' = 'warning'
  ) => {
    dispatch(
      setDialog({
        isOpen: true,
        message,
        type,
      })
    );
  },
  confirm: (
    dispatch: AppDispatch,
    message: string,
    onConfirm: () => void,
    onClose?: () => void
  ) => {
    dispatch(
      setDialog({ isOpen: true, message, type: 'confirm', onConfirm, onClose })
    );
  },
};

export const { closeDialog } = dialogSlice.actions;
export default dialogSlice.reducer;
